import { motion } from 'framer-motion';
import { cn } from '../../lib/cn';
import { useReducedMotion } from '../../hooks/useReducedMotion';

type StatusTone = 'online' | 'warn' | 'critical';

const toneClasses: Record<StatusTone, string> = {
  online: 'bg-brand-lime shadow-[0_0_14px_rgba(183,255,106,0.9)]',
  warn: 'bg-amber-300 shadow-[0_0_14px_rgba(252,211,77,0.8)]',
  critical: 'bg-rose-400 shadow-[0_0_16px_rgba(251,113,133,0.8)]'
};

export const StatusChip = ({
  label,
  tone = 'online',
  className
}: {
  label: string;
  tone?: StatusTone;
  className?: string;
}) => {
  const reducedMotion = useReducedMotion();

  return (
    <span className={cn('inline-flex items-center gap-2 rounded-full border border-brand-lime/25 bg-brand-panel px-3 py-1', className)}>
      <motion.span
        className={cn('h-2.5 w-2.5 rounded-full', toneClasses[tone])}
        animate={
          reducedMotion
            ? undefined
            : {
                opacity: [0.45, 1, 0.55],
                scale: [0.92, 1.15, 1]
              }
        }
        transition={{ duration: 1.8, repeat: Infinity, ease: 'easeInOut' }}
      />
      <span className="hud-micro text-brand-text-2">{label}</span>
    </span>
  );
};
